<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('internship_application')" :isFilter="false"></Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('internship_application')" :isFilter="false"></HeaderMobile>
            </template>
            <div v-if="show_warning" class="d-flex justify-content-center align-items-center" style="height:100vh">
                <b-card no-body class="overflow-hidden" style="max-width: 740px;">
                    <b-row no-gutters>
                        <b-col md="6">
                            <b-card-img :src="image" alt="Image" class="rounded-0"></b-card-img>
                        </b-col>
                        <b-col md="6">
                            <b-card-body :title="$t('internship_application').toUpper()">
                                <b-card-text>
                                    {{$t('internship_not_semester_date')}}
                                </b-card-text>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <div class="row data-form" v-else>
                <div class="col-12" >
                    <ValidationObserver ref="documentForm">
                        <div class="mb-2">
                            <h6 class="mb-0">{{ $t('student_information') | toUpperCase }}</h6>
                        </div>
                        <div class="border px-5 pt-5 pb-2 mb-4 rounded">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('student_number')">
                                        {{ userData.student_number }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('name_surname')">
                                        {{ userData.name + ' ' + userData.surname }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('nationality')">
                                        {{ userData.nationality_code }}
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('faculty')">
                                        {{ getLocaleText(userData,'faculty_name') }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('program')">
                                        {{ getLocaleText(userData,'program_name') }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('class')">
                                        {{ getLocaleText(userData,'class_name') }}
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('email')">
                                        {{ userData.email }}
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="company_name" rules="required" v-slot="{valid, errors}" >
                                            <b-form-group :label="$t('company_name')">
                                                <b-form-input v-model="formData.company_name">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                            </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="company_address" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('company_address')">
                                            <b-form-input v-model="formData.company_address">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="company_phone" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('company_phone')">
                                            <b-form-input
                                                v-model="formData.company_phone"
                                                v-mask="'(###)-###-####'"
                                                :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="responsible_name" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('internship_manager_name')">
                                            <b-form-input v-model="formData.responsible_name">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="responsible_surname" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('internship_manager_surname')">
                                            <b-form-input v-model="formData.responsible_surname">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="responsible_email" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('internship_manager_email')">
                                            <b-form-input v-model="formData.responsible_email">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="unit" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('unit')">
                                            <b-form-input v-model="formData.unit">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="day_count" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('total_number_of_working_days')">
                                            <b-form-input v-model="formData.day_count" type="number">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="internship_type" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('internship_type')">
                                            <parameter-selectbox
                                                :validate-error="errors[0]"
                                                code="internship_type"
                                                v-model="formData.type"
                                            ></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="!['voluntary'].includes(formData.type)">
                                    <ValidationProvider name="course_code_1" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="`${$t('course_code')}`">
                                            <multi-selectbox v-model="formData.course_code"
                                                             :options="coursesOptions"
                                                             :validate-error="errors[0]"
                                            ></multi-selectbox>

                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('start_date')">
                                            <select-date v-model="formData.start_date" :is-time="true" :state="errors[0] ? false : null" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('end_date')">
                                            <select-date v-model="formData.end_date" :is-time="true" :state="errors[0] ? false : null" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="job_description" rules="required|max:240" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('job_description')">
                                            <b-form-textarea v-model="formData.job_description"
                                                             :class="errors[0] ? 'is-invalid':''"
                                                             rows="5"
                                            />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="files" :rules="userData.nationality_code !== 'TR' ? 'required' : ''"
                                                        v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('employment_certificate')">
                                            <div class="d-flex custom-file-upload">
                                                <b-form-file v-model="formData.working_document"
                                                             :state="errors[0] ? false : (valid ? true : null)"
                                                             :placeholder="$t('select_file')"
                                                             accept="image/jpeg, image/png, image/gif, image/jpg, application/pdf, .doc, .docx, application/msword"
                                                             :drop-placeholder="$t('drop_file')" ref="fileInput"
                                                             ></b-form-file>
                                                <b-button variant="outline-secondary"
                                                          @click="$refs.fileInput.$el.childNodes[0].click();">
                                                    {{ $t('browse') }}
                                                </b-button>
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <b-form-group>
                        <b-button variant="primary" @click="sendForm">{{$t('save')}}</b-button>
                    </b-form-group>
                </div>
            </div>
        </app-layout>

    </div>
</template>


<script>
import image from "@/assets/img/application-form.jpg"

    // Components
    import AppLayout from '@/layouts/AppLayout';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';
    import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete";
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import internshipApplicationService from "@/services/InternshipApplicationService";
    export default {
    components: {
        AppLayout,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver,
        CourseAutoComplete
    },
    data() {
        return {
            image,
            show_warning:false,
            formData: {
                company_name: null,
                company_address: null,
                company_phone: null,
                responsible_name: null,
                responsible_surname: null,
                responsible_email: null,
                unit: null,
                day_count: null,
                course_code: null,
                type: null,
                start_date: null,
                end_date: null,
                job_description: null,
                working_document: null
            },
            userData: {
                nationality_code: null
            },
        }
    },
        computed: {
          coursesOptions(){
              let options = [];
              if (!this.userData.course_with_slots) return [];
              Object.entries(this.userData.course_with_slots).forEach(([key, value]) => {
                  options.push({
                      text:key,
                      value:key
                  })
              })
              return options
          }
        },
    methods: {
        getData() {
            internshipApplicationService.getInternshipStudent()
                                  .then(response => {
                                      this.userData = response.data.data
                                  }).catch(error => {
                                       if (error.data.message==="SEMESTER_DATE_NOT_FOUND"){
                                           this.show_warning = true
                                       }

                                      this.showErrors(error)
                                  })
        },
        async sendForm() {
            const isValid = await this.$refs.documentForm.validate();
            if (isValid) {
                if(this.formData.type==='voluntary'){
                    delete this.formData.course_code
                }
                const formData = new FormData();
                Object.entries(this.formData).forEach(([key, value]) => {
                    if (key==='working_document' && this.userData.nationality_code === 'TR') {
                        return
                    }
                    formData.append(key, value);
                })
                internshipApplicationService.internshipApplication(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.documentForm);
                    });
            }
        },
    },
    created() {
        this.getData()
    }
}
</script>

<style>

.auto-as-parent{
    height: 100%;
    width: 100%;
}

</style>

